import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import type { CourseItemViewModel } from '../../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaItemViewModel/agendaItemViewModel';
import { classes, st } from './CourseDetails.st.css';

export const COURSE_DATE_RANGE_DATA_HOOK = 'agenda-item-course-date-range';
export const COURSE_STATUS_DATA_HOOK = 'agenda-item-course-status';

export type CourseDetailsProps = {
  course?: CourseItemViewModel;
  theme?: 'default' | 'onImage';
};

/**
 * The status and the date range of a course row, in that order
 * (Figma 4235-115629). Renders nothing when `course` is undefined, which covers
 * a class and the experiment being off.
 */
export const CourseDetails: FC<CourseDetailsProps> = ({
  course,
  theme = 'default',
}) => {
  const { isMobile } = useEnvironment();

  if (!course) {
    return null;
  }

  return (
    <div
      className={st(classes.root, { isMobile, onImage: theme === 'onImage' })}
    >
      {course.statusText && (
        <Text data-hook={COURSE_STATUS_DATA_HOOK} className={classes.status}>
          {course.statusText}
        </Text>
      )}
      {course.dateRange && (
        <Text
          data-hook={COURSE_DATE_RANGE_DATA_HOOK}
          className={classes.dateRange}
        >
          {course.dateRange}
        </Text>
      )}
    </div>
  );
};
